<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bCs0fy/tc-custom/9783985314508.jpg?1702956303978" alt="This image is the cover for the book Kokoro, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kokoro, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Auszug: "Er war in einer Stadt im Innern des Landes geboren, der Residenz eines Daimyo mit einem Territoriumbesitz von hunderttausend Koko (altes japanisches Maß). Kein Fremder hatte die Gegend jemals betreten. Die Yashiki Residenz eines Daimyo. seines Vaters, eines Samurai von hohem Rang, lag innerhalb der äußern Festungsmauern, von denen der fürstliche Palast umgeben war. Es war eine weitläufige Yashiki, und dahinter und ringsum dehnten sich Landschaftsgärten. In einem derselben stand ein kleiner Tempel mit dem Bildnis des Kriegsgottes. Vor vierzig Jahren gab es viele solche Residenzen. Künstleraugen erscheinen die wenigen noch übriggebliebenen wie Feenpaläste und ihre Gärten wie buddhistische Paradiesesträume."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lafcadio Hearn
      </h2>
      
      <p class="authorDescription body article">Patricio Lafcadio Tessima Carlos Hearn (jap. Koizumi Yakumo; * 27. Juni 1850 auf Lefkas, Griechenland; † 26. September 1904 in Tokio) war ein Schriftsteller irisch-griechischer Abstammung, dessen Werke das westliche Bild von Japan im beginnenden 20. Jahrhundert entscheidend geprägt haben.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c5b103de